import { render, staticRenderFns } from "./GradientControls.vue?vue&type=template&id=08e0c49e&"
import script from "./GradientControls.vue?vue&type=script&lang=ts&"
export * from "./GradientControls.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports